/**
 * @generated SignedSource<<6beed2a7872d1044172d233516064288>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask$data = {
  readonly __typename: "WorkSuggestionsPullRequestNeedsWorkTask";
  readonly commentCount: number;
  readonly destinationBranchName: string | null | undefined;
  readonly id: string;
  readonly providerIconUrl: string | null | undefined;
  readonly providerName: string | null | undefined;
  readonly repositoryName: string | null | undefined;
  readonly reviewers: ReadonlyArray<{
    readonly __typename: "WorkSuggestionsUserDetail";
  } | null | undefined> | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask";
};
export type pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask$key = {
  readonly " $data"?: pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "pullRequestNeedsWork_periscope_PullRequestNeedsWorkTask",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "commentCount"
    },
    {
      "kind": "ScalarField",
      "name": "destinationBranchName"
    },
    {
      "kind": "ScalarField",
      "name": "providerName"
    },
    {
      "kind": "ScalarField",
      "name": "providerIconUrl"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryName"
    },
    {
      "concreteType": "WorkSuggestionsUserDetail",
      "kind": "LinkedField",
      "name": "reviewers",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ],
  "type": "WorkSuggestionsPullRequestNeedsWorkTask"
};
})();

(node as any).hash = "6a9a3d99803f2ed6a6359a3f3731e190";

export default node;
